import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

const estado = {
    protocolo: null
}

const mutations = {
    'USUARIO_LOGADO'(state, { protocolo }) {
        state.protocolo = protocolo
    },
    'USUARIO_DESLOGADO'(state) {
        state.protocolo = null
    }
}

export default new Vuex.Store({
    state: estado,
    mutations
})
